import { useEffect, useState } from "react";
import { Download, Share, SquarePlus, X, Zap, MoreVertical } from "lucide-react";
import { canPromptInstall, subscribeInstall, promptInstall, isStandalone, isIOS, OPEN_INSTALL_EVENT } from "@/lib/installPrompt";

const DISMISS_KEY = "lf-install-dismissed";

const Steps = ({ ios }) => (
  <ol className="mt-3 space-y-2 text-sm text-zinc-700" data-testid="install-steps">
    {ios ? (
      <>
        <li className="flex items-center gap-2"><span className="font-mono-accent text-xs text-[#FF5A00]">1</span> Tap <Share className="w-4 h-4"/> Share at the bottom of Safari</li>
        <li className="flex items-center gap-2"><span className="font-mono-accent text-xs text-[#FF5A00]">2</span> Choose <SquarePlus className="w-4 h-4"/> Add to Home Screen</li>
        <li className="flex items-center gap-2"><span className="font-mono-accent text-xs text-[#FF5A00]">3</span> Tap Add</li>
      </>
    ) : (
      <>
        <li className="flex items-center gap-2"><span className="font-mono-accent text-xs text-[#FF5A00]">1</span> Tap <MoreVertical className="w-4 h-4"/> the browser menu</li>
        <li className="flex items-center gap-2"><span className="font-mono-accent text-xs text-[#FF5A00]">2</span> Choose Install app or Add to Home screen</li>
      </>
    )}
  </ol>
);

export const InstallAppPrompt = () => {
  const [show, setShow] = useState(() => !isStandalone() && !localStorage.getItem(DISMISS_KEY));
  const [canPrompt, setCanPrompt] = useState(canPromptInstall());
  const ios = isIOS();

  useEffect(() => subscribeInstall(() => setCanPrompt(canPromptInstall())), []);
  useEffect(() => {
    const open = () => setShow(true);
    window.addEventListener(OPEN_INSTALL_EVENT, open);
    return () => window.removeEventListener(OPEN_INSTALL_EVENT, open);
  }, []);

  if (!show || isStandalone()) return null;
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => { if (await promptInstall()) setShow(false); };

  return (
    <div className="lg:hidden fixed inset-x-3 bottom-36 z-20 bg-white border border-zinc-200 rounded-2xl shadow-xl p-4" data-testid="install-app-prompt">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#FF5A00] flex items-center justify-center shrink-0">
          <Zap className="w-5 h-5 text-white" strokeWidth={2.5}/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold text-zinc-900">Add LeadForge to your home screen</div>
          <div className="text-xs text-zinc-500 mt-0.5">Opens full screen like an app, one tap away.</div>
        </div>
        <button type="button" onClick={dismiss} className="p-1 -mr-1 text-zinc-400 hover:text-zinc-900" aria-label="Dismiss" data-testid="install-dismiss-btn">
          <X className="w-4 h-4"/>
        </button>
      </div>
      {canPrompt && !ios ? (
        <button type="button" onClick={install} data-testid="install-app-btn"
          className="mt-3 w-full flex items-center justify-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] text-white text-sm font-medium rounded-lg py-2.5 transition-colors">
          <Download className="w-4 h-4"/> Install app
        </button>
      ) : <Steps ios={ios}/>}
    </div>
  );
};
